export const API = {
  CITY: {
    TYPE: 'GET',
    URL: (term: string) => `/location/${term}`,
  },
};

export interface CITY_ITEM_DATA_RAW_INTER {
  id: number;
  adm1: string;
  adm2: string;
  adm3: string;
  adm4: string;
  code1: string;
  code2: string;
  code3: string;
  code4: string;
  category: string;
}

export type CITY_LIST_RAW_INTER = CITY_ITEM_DATA_RAW_INTER[];
